import fieldNames from '../constants/field-names';
import getPathPrefix from './get-path-prefix';

const resolvePageTitle = (values) =>
  values[fieldNames.USE_PAGE_NAME_FOR_PAGE_TITLE]
    ? values[fieldNames.NAME]
    : values[fieldNames.TITLE];

const resolveOpenGraphTitle = (values) =>
  values[fieldNames.USE_PAGE_TITLE_FOR_OG_TITLE]
    ? resolvePageTitle(values)
    : values[fieldNames.OG_TITLE];

const resolveOpenGraphDescription = (values) =>
  values[fieldNames.USE_PAGE_DESCRIPTION_FOR_OG_DESCRIPTION]
    ? values[fieldNames.DESCRIPTION]
    : values[fieldNames.OG_DESCRIPTION];

const resolveCanonicalUrl = (values, { canonicalSiteUrl, locale, isPageMainLocale }) => {
  if (!values[fieldNames.USE_PAGE_URL_FOR_CANONICAL_URL]) {
    return values[fieldNames.CANONICAL_URL];
  }

  const urlPrefix = isPageMainLocale ? canonicalSiteUrl : getPathPrefix(canonicalSiteUrl, locale);
  return `${urlPrefix}${values[fieldNames.PATH]}`;
};

export {
  resolvePageTitle,
  resolveOpenGraphTitle,
  resolveOpenGraphDescription,
  resolveCanonicalUrl,
};
